import React, { Component } from "react";
import styled from "styled-components";

import orangeSymbol from "./../../images/mb/orange_symbol.png";
import whiteSymbol from "./../../images/mb/white_symbol.png";

export default class HeadingAndDescription extends Component {
  render() {
    const Image = styled.img`
      filter: ${element === "white" ? "brightness(8)" : null};
    `;
    const { heading, description, color, element } = this.props;

    return (
      <div className="row text-center">
        <div className="col-sm-6 headingDescription-title">
          <h2>
            <Image
              src={element === "orange" ? orangeSymbol : whiteSymbol }
              className="headingDescription-titleSymbol"
            />
            {heading}
          </h2>
        </div>
        <div className="col-sm-6 headingDescription-description">
          <p dangerouslySetInnerHTML={{ __html: description }} />
        </div>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HeadingAndDescription/index.js